export default __webpack_public_path__ + "static/media/cny-flower-1.9b33495c.webp";